import { useContext, useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import { ContextApp } from './contexts/ContextApp';
import { IRouteConfig } from './interfaces/routeConfig';
import routes from './routes/routes';
import SendActivity from './sendActivity';
import { useLocation } from 'react-router';

interface AppContentProps {
  onRouteChange?: (route: string) => void;
}

const AppContent = ({ onRouteChange }: AppContentProps) => {
  const location = useLocation();
  const { t } = useContext(ContextApp);
  useEffect(() => {
    onRouteChange && onRouteChange(location.pathname);
  }, [location]);
  const recursiveRouteTranslate = (routes: IRouteConfig[]) => {
    routes.forEach((route) => {
      if (route.translation_key) route.name = t(route.translation_key as never);
      if (route.routes) recursiveRouteTranslate(route.routes);
    });
  };
  recursiveRouteTranslate(routes);

  SendActivity();
  return renderRoutes(routes);
};

export default AppContent;
